import React from 'react'
import { Avatar, AvatarGroup, Tooltip } from '@mui/material'
import { User } from 'types'

interface Assignee {
  user_uuid: string
  name: string
  image_512?: string
}

interface AssigneeAvatarsProps {
  assignees: User[]
  sizes?: { height?: number; width?: number }
  max?: number // Optional max number of avatars to display
  showTooltip?: boolean
  id?: string
}

const AssigneeAvatars: React.FC<AssigneeAvatarsProps> = ({ assignees, sizes, max = 4, showTooltip = true, id }) => {
  if (!assignees || assignees.length === 0) return null
  return (
    <AvatarGroup
      max={max}
      slotProps={{
        additionalAvatar: { sx: { width: sizes?.width ?? 28, height: sizes?.height ?? 28 } },
      }}
    >
      {assignees.map(assignee => (
        <Tooltip key={id ? `${id}-${assignee.user_uuid}` : assignee.user_uuid} title={showTooltip ? assignee.name : ''}>
          <Avatar
            alt={assignee.name}
            src={assignee.image_512}
            sx={{ width: sizes?.width ?? 28, height: sizes?.height ?? 28, fontSize: 12 }}
          >
            {!assignee.image_512 && assignee.name?.charAt(0)}
          </Avatar>
        </Tooltip>
      ))}
    </AvatarGroup>
  )
}

export default AssigneeAvatars
